import React from 'react';
import { motion } from 'framer-motion';
interface GlowButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  variant?: 'primary' | 'secondary';
  className?: string;
  fullWidth?: boolean;
}
export function GlowButton({
  children,
  onClick,
  disabled = false,
  variant = 'primary',
  className = '',
  fullWidth = false
}: GlowButtonProps) {
  const isPrimary = variant === 'primary';
  return <motion.button onClick={onClick} disabled={disabled} className={`
        ${fullWidth ? 'w-full' : ''} 
        px-8 py-4 rounded-full font-semibold text-base tracking-wide
        transition-all duration-300
        ${isPrimary ? 'bg-accent-pink text-white glow-pink hover:glow-pink-subtle' : 'bg-white/5 text-white border border-white/10 hover:border-accent-pink hover:glow-pink-subtle'}
        ${disabled ? 'opacity-40 cursor-not-allowed' : 'cursor-pointer'}
        ${className}
      `} whileHover={!disabled ? {
    scale: 1.02
  } : {}} whileTap={!disabled ? {
    scale: 0.98
  } : {}} animate={!disabled && isPrimary ? {
    boxShadow: ['0 0 30px rgba(255, 45, 111, 0.5)', '0 0 40px rgba(255, 45, 111, 0.6)', '0 0 30px rgba(255, 45, 111, 0.5)']
  } : {}} transition={{
    boxShadow: {
      duration: 2,
      repeat: Infinity,
      ease: 'easeInOut'
    }
  }} data-id="element-7">
      {children}
    </motion.button>;
}